import { createGlobalStyle } from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const GlobalStyled = createGlobalStyle`
    :root {
        // COLORS
        --color-base: #131420;
        --color-base-secondary: #1B1C2D;
        --color-main: #42456C;
        --color-surface: #262840;
        --color-surface-highlight: #393C60;
        --color-surface-secondary: #31324E;
        --color-yellow: #FFDD3C;
        --color-yellow-60: #FFDD3C99;
        --color-yellow-80: #FFDD3CCC;
        --color-yellow-light: #FFEFA3;
        --color-yellow-dark: #A38600;
        --color-white: #FFFFFF;
        --color-white-60: rgba(255, 255, 255, 0.6);
        --color-white-95: rgba(255, 255, 255, 0.95);
        --color-purple: #393C5D;
        --color-purple-highlight: #5F649B;
        --color-green: #54EEAB;
        --color-green-secondary: #14C679;
        --color-green-secondary-20: #14C67933;
        --color-red: #FF858B;
        --color-red-secondary: #D05257;
        --color-black: #2A2B30;
        --color-secondary: #BDC0DB;
        --color-secondary-active: #7D86B2;
        --color-secondary-highlight: #B9BFDF;
        --color-positive: #54EEAB;
        --color-negative: #FF858B;
        --color-negative-secondary: #FF646C;
        --color-negative-secondary-20: #FF646C33;
        --color-negative-lite: #FF999E;
        --color-neutral: #8192E4;
        --color-neutral-10: #8192E41A;
        --color-neutral-20: #8192E433;
        --color-neutral-40: #8192E466;

        --text-color-secondary: #A3A6CC;
        --text-color-dark: #0A0A10;

        --app-bg-color: #131420;
        --app-bg-header-color: #1E1F30;
        --app-bg-modal-color: var(--color-surface);
        --app-bg-modal-header-color: var(--color-surface-secondary);
        --app-bg-modal-panel-color: var(--color-surface-secondary);
        --dx-bg-color: var(--color-surface-secondary);

        --brand-color: #FFDD3C;

        --icon-primary-color: #CAD0E7;
        --background-base: #0A0A10;
        --background-logo: #1A1B23;
        --background-positive: #14C679;
        --background-positive-20: #14C67933;
    }

    html, body {
        height: 100%;
    }

    #root {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    body {
        font-family: "OpenSans", sans-serif;
        font-size: 16px;
        font-weight: 400;

        background-color: var(--app-bg-color);
        color: white;
        margin: 0;
        padding: 0;
    }

    .app {
        * {
            //user-select: none !important;
        }
    }

    .positive {
        color: var(--color-green);
    }

    .negative {
        color: var(--color-red);
    }

    /**
     * Typographic
     */

    h1 {
        font-size: 40px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 32px;
        }
    }

    h2 {
        font-size: 32px;
        font-weight: 600;
    }

    h3 {
        font-size: 28px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 24px;
        }
    }

    h4 {
        font-size: 24px;
        font-weight: 600;
    }

    h5 {
        font-size: 20px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 16px;
        }
    }

    h6 {
        font-size: 16px;
        font-weight: 600;
    }

    @media (max-width: ${BREAKPOINTS.extraExtraLarge}px) {
        body {
            font-size: 16px;
        }
    }

    @media (max-width: ${BREAKPOINTS.large}px) {
        body {
            font-size: 16px;
        }
    }

    @media (max-width: ${BREAKPOINTS.medium}px) {
        body {
            font-size: 16px;
        }
    }

    @media (max-width: ${BREAKPOINTS.small}px) {
        body {
            font-size: 14px;
        }
    }

    a[type='button'] {
        -webkit-appearance: none;
    }

    .flex-row {
        display: flex;
        flex-direction: row;

        > * {
            flex: 1 1 auto;
        }
    }

    /**
     * BOOTSTRAP    
     */

    .dropdown-menu {
        background-color: var(--color-surface-secondary);
        border: none;
        box-shadow: 0 4px 25px rgba(0, 0, 0, 0.25);
        border-radius: 2px;
    }

    .dropdown-divider {
        margin: 0;
        border-top: 1px solid var(--color-main);
        opacity: 1;
    }

    .dropdown-header {
        font-size: 14px;
        font-weight: 400;
        color: var(--text-color-secondary);
        padding: 12px 16px;
    }

    .dropdown-item {
        font-size: 14px;
        font-weight: 600;
        color: var(--color-white);
        padding: 12px 16px;

        &.secondary {
            color: var(--text-color-secondary);

            &:hover,
            &:focus {
                color: var(--text-color-secondary);
            }
        }

        &.active,
        &:active {
            color: var(--color-white);
            background-color: var(--color-surface);
        }

        &:hover,
        &:focus {
            color: var(--color-white);
            background-color: var(--color-surface);
        }
    }

    .carousel .slide {
        text-align: unset;
    }

    .badge {
        border-radius: 8px;
        font-size: 16px;
        font-weight: 600;
    }

    .bg-info {
        background-color: var(--color-surface) !important;
    }
`;
